import { render } from "./PaginatorContent.vue?vue&type=template&id=57bd091b&ts=true"
import script from "./PaginatorContent.vue?vue&type=script&lang=ts"
export * from "./PaginatorContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__